import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion";

export default function CTABanner({ title = "Let's Build Something Exceptional Together", subtitle = "Tell us where you want to go. We'll engineer the way there.", cta = "Get a Free Consultation" }) {
  return (
    <section className="px-5 sm:px-8 py-20 lg:py-28" data-testid="cta-banner-section">
      <Reveal className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl bg-[#01193D] px-8 sm:px-16 py-16 lg:py-24 text-center border border-white/10">
          <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-[#2563EB]/20 blur-3xl" />
          <div className="absolute -bottom-28 -right-16 w-80 h-80 rounded-full bg-[#09B2ED]/15 blur-3xl" />
          <div className="absolute inset-0 dot-grid-light opacity-20" />
          <div className="relative">
            <h2 className="font-display font-bold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-3xl mx-auto leading-tight">
              {title}
            </h2>
            <p className="text-slate-300 text-base lg:text-lg mt-5 max-w-xl mx-auto">{subtitle}</p>
            <Link
              to="/contact"
              data-testid="cta-banner-button"
              className="inline-flex items-center gap-2 mt-9 bg-white text-[#01193D] text-sm font-semibold px-8 py-3.5 rounded-full hover:bg-slate-100 transition-all shadow-lg"
            >
              {cta} <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
